const DEV_GUIDE_URL = 'http://localhost:8080/guide';
const PROD_GUIDE_URL = 'https://keyfiyathava.ahooai.ir/guide';

export const GUIDE_URL = __DEV__ ? DEV_GUIDE_URL : PROD_GUIDE_URL;
